import { render, staticRenderFns } from "./changeApplicationDetails.vue?vue&type=template&id=088bdcbc&scoped=true&"
import script from "./changeApplicationDetails.vue?vue&type=script&lang=js&"
export * from "./changeApplicationDetails.vue?vue&type=script&lang=js&"
import style0 from "./changeApplicationDetails.vue?vue&type=style&index=0&id=088bdcbc&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "088bdcbc",
  null
  
)

export default component.exports